import { render, staticRenderFns } from "./Optouts.vue?vue&type=template&id=061ed9a8&scoped=true"
import script from "./Optouts.vue?vue&type=script&lang=js"
export * from "./Optouts.vue?vue&type=script&lang=js"
import style0 from "./Optouts.vue?vue&type=style&index=0&id=061ed9a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ed9a8",
  null
  
)

export default component.exports